import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase/firebase";

export async function sendMessage( receiverId: string, message: string ) {
    const sendMessage = httpsCallable(functions, "sendMessage");

    await sendMessage({ userId: receiverId, message: message }).catch((error) => {
        throw new Error(error);
    });
}

export async function readMessages( senderId: string ) {
    const readMessages = httpsCallable(functions, "readMessages");

    await readMessages({ userId: senderId }).catch((error) => {
        throw new Error(error);
    });
}